import React from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import MinistryForm from '../Form';
import { createMinistry } from '@resources/Ministry/actions';
import { useIntl } from 'react-intl';

const Create = (props) => {
	const { createMinistry, visible, onCancel } = props;
	const intl = useIntl();
	const handleSubmit = (data) => {
		return createMinistry(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.ministry.create',
						defaultMessage:
							'A new Ministry has been successfully created',
					})
				);

				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.ministry',
					defaultMessage: 'Create Ministry',
				})}
			</Title>
			<MinistryForm onSubmit={handleSubmit} {...props} />
		</Modal>
	);
};

const mapStateToProps = ({ organization }) => {
	return {
		organization,
	};
};

export default connect(mapStateToProps, { createMinistry })(Create);
